import React, { useEffect, useState } from "react";
import { TextField, Typography, Button } from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import ValidationError from "../validation-error-label";
import Color from "../../theme/color";

interface ImageSelectionProps {
  onImagesSelected: (
    images: { name: string; data: string; id: number }[]
  ) => void;
  allowMultiple: boolean;
  label?: string | "Choose Image";
  formErrors: any;
}

const ImageSelectionComponent: React.FC<ImageSelectionProps> = ({
  onImagesSelected,
  allowMultiple,
  label,
  formErrors,
}) => {
  const [selectedImages, setSelectedImages] = useState<
    { name: string; data: string; id: number }[]
  >([]);
  const allowedFileTypes = ["image/jpeg", "image/jpg", "image/png"];
  const [isCoveredImageValidation, setIsCoveredImageValidation] = useState("");

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;

    if (files && files.length > 0) {
      const newImages = new Set<{ name: string; data: string; id: number }>(
        selectedImages
      );

      for (let i = 0; i < files.length; i++) {
        if (allowedFileTypes.includes(files[i].type)) {
          const file = files[i];
          const reader = new FileReader();

          reader.onload = () => {
            const base64String = reader.result?.toString();
            if (base64String) {
              newImages.add({ name: file.name, data: base64String, id: 0 });
            }

            if (!allowMultiple) {
              setSelectedImages(Array.from(newImages).slice(-1));
            } else {
              setSelectedImages(Array.from(newImages));
            }
          };

          reader.readAsDataURL(file);
        } else {
          setIsCoveredImageValidation(
            "Please select a valid JPEG, JPG, or PNG file."
          );
          e.target.files = null;
        }
      }
    }
  };

  React.useEffect(() => {
    onImagesSelected(selectedImages);
  }, [selectedImages, onImagesSelected]);
  return (
    <div>
      <TextField
        size="small"
        type="file"
        inputProps={{ multiple: allowMultiple }}
        label={label}
        fullWidth
        InputLabelProps={{
          shrink: true,
        }}
        onChange={handleImageChange}
      />
      <Typography sx={{ fontSize: "14px", color: Color.red }}>
        {isCoveredImageValidation}
      </Typography>
      <Typography
        sx={{
          width: "100%",
          fontSize: 12,
          color: "green",
        }}
      >
        Image size should be less than 10mb and in .jpg, .png formats
        <br />
        An ideal size for the images is 960 * 536 pixels
      </Typography>
      <div>
        {selectedImages.map((image, index) => {
          const handleDeleteClick = () => {
            const newData = [...selectedImages];
            newData.splice(index, 1);
            setSelectedImages(newData);
          };
          return (
            <div key={index}>
              <img
                src={image.data}
                style={{ width: "100px", height: "100px", marginRight: "10px" }}
                alt={`Image ${index}`}
              />
              <Typography variant="caption" alignItems={"center"}>
                {image.name}{" "}
                <Button onClick={handleDeleteClick}>
                  {" "}
                  <DeleteForeverIcon color="error" />
                </Button>
              </Typography>
              {formErrors[`otherImage-${index}`] && (
                <ValidationError
                  formErrors={formErrors[`otherImage-${index}`]}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ImageSelectionComponent;
